const Events = () => {
    const __listener = {},
        returnObj = {
            /**
             * add listener.
             * @param type {String} typ des listeners bzw. name
             * @param callback {Function}
             * @param context {Object?}
             */
            addListener: function (type, callback, context) {
                "use strict";
                __listener[type] || (__listener[type] = []);
                __listener[type].push({ 'func': callback, 'context': context });
            },

            /**
             * add listener for one call.
             * @param type {String} typ des listeners bzw. name
             * @param callback {Function}
             * @param context {Object?}
             */
            addListenerOnce: function (type, callback, context) {
                "use strict";
                __listener[type] || (__listener[type] = []);
                __listener[type].push({ 'func': callback, 'context': context, 'once': true });
            },

            /**
             * reset all listener.
             * @param type
             */
            resetEvent: function (type) {
                __listener[type] && (delete __listener[type]);
            },

            /**
             * fire data event.
             *
             * @param type
             * @param data
             */
            fireDataEvent: function (type, data) {
                "use strict";
                if (__listener[type]) {
                    (typeof data !== 'object' || typeof data.length === 'undefined') && (data = [data]);
                    let i = 0;
                    for (i = 0; i < __listener[type].length; i++) {
                        if (!__listener[type][i]) {
                            continue;
                        }
                        Promise.resolve(i).then((i) => {
                            __listener[type][i].func.apply(__listener[type][i].context ? __listener[type][i].context : this, data);
                            if (__listener[type][i].once) {
                                __listener[type].splice(i, 1);
                            }
                        });

                    }
                }
            }
        };
    return returnObj;
}
export const events = Events();
